export const StateMachine = {
  SELECT_DATES: "SELECT_DATES",
  MEETING_TITLE: "MEETING_TITLE",
  NAME: "NAME",
  GENERAL_AVAIL: "GENERAL_AVAIL",
  SPECIFIC_AVAIL: "SPECIFIC_AVAIL",
  LOADING: "LOADING"
};